/**
 * Build a descriptive export filename for reports.
 *
 * Format: {prefix}_{brand}_du-{dateFrom}_au-{dateTo}_export-{now}
 * Example: rapport_stock_Quick_Masurel_du-01-03-26-08h30_au-15-03-26-08h30_export-24-03-26-17h13
 */
export function buildExportFileName(
  prefix: string,
  brandName: string,
  dateFrom?: string | Date | null,
  dateTo?: string | Date | null,
): string {
  const brandSlug = brandName.replace(/\s+/g, '_');
  const pad = (n: number) => String(n).padStart(2, '0');

  const formatDt = (d: Date) => {
    return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${String(d.getFullYear()).slice(2)}-${pad(d.getHours())}h${pad(d.getMinutes())}`;
  };

  const now = new Date();
  const exportTs = `export-${formatDt(now)}`;

  if (dateFrom && dateTo) {
    const from = typeof dateFrom === 'string' ? new Date(dateFrom) : dateFrom;
    const to = typeof dateTo === 'string' ? new Date(dateTo) : dateTo;
    return `${prefix}_${brandSlug}_du-${formatDt(from)}_au-${formatDt(to)}_${exportTs}`;
  }

  return `${prefix}_${brandSlug}_${exportTs}`;
}
